<div class="col-lg-12">
  <div class="row child">
    <p-card class="card-spacing-0">
      <div class="p-3 pt-0">
        <span
          class="d-flex justify-content-between align-items-center pb-2 mb-2 globalborder-btm-header">
          <span class="col-auto d-flex align-items-center">
            <span>
              <h2 class="mb-0">
                Lines Group Items
                <!-- <jni-spinner *ngIf="showSmallLoader"></jni-spinner> -->
              </h2>
            </span>
          </span>
          <span class="d-flex gap-2 customizefilter-btn">
            <span class="cross-border" (click)="onCancel()"
              ><i class="pi pi-times"></i
            ></span>
          </span>
        </span>

        <div class="align-items-center d-flex col-lg-12 mb-3 mt-3">
          <div class="nav-link p-0 d-flex align-items-center">
            <a class="link-col" (click)="onSave()"
              ><i class="pi pi-save"></i> Save</a
            >
          </div>

          <div class="ms-3 nav-link p-0 d-flex align-items-center">
            <a class="link-col" (click)="createNewLineGroup()"
              ><i class="pi pi-plus"></i> New</a
            >
          </div>

          <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
            <a class="link-col delcol" (click)="onDeleteLineGroup()">
              <i class="pi pi-trash"></i> Delete</a
            >
          </div>

          <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
            <a class="link-col" (click)="calculateNet()"
              ><i class="pi pi-calculator"></i> Calculate NET</a
            >
          </div>

          <div class="ms-3 nav-link p-0 d-flex align-items-center btncommit">
            <a class="link" (click)="confirmLineGroup()"
              ><i class="pi pi-comment"></i> Commit
            </a>
          </div>

          <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
            <a class="link-col" (click)="completeComfirmationForInvPO()"
              ><i class="pi pi-verified"></i> Confirm PO</a
            >
          </div>
          <div
            class="ms-3 nav-link p-0 d-flex align-items-center delete"
            *ngIf="openPrinfPdfFlag">
            <i class="icon-BCledger me-2"></i>
            <a class="link-col" (click)="openPrinfPdfModal()"
              >Child PO confirmations</a
            >
          </div>

          <!-- <div class="ms-3 nav-link p-0 d-flex align-items-center delete">
      <a class="link-col">Clild PO confirmations</a>
    </div> -->
        </div>

        <div
          class="col-12 collapseable inventory-section adduser-container-hgt">
          <div class="d-flex gap-3">
            <div class="linegroup-left">
              <div class="col">
                <div class="gray-bg-rounded">
                  <h2 class="mb-3">Line Group</h2>
                  <div class="row">
                    <ul class="custom-list">
                      <a
                        *ngFor="let item of linesGroup"
                        [class.selected]="item === selectedLineGroup"
                        class="d-block"
                        (click)="selectItem(item)">
                        <span
                          class="left-side"
                          *ngIf="item === selectedLineGroup"></span>
                        <span class="item-content">{{ item }}</span>
                      </a>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div class="linegroup-right">
              <div class="col fixingflexcol">
                <div
                  class="d-flex mb-2 justify-content-start gap-2 align-items-center">
                  <h2 class="mb-0">Purchase Order Line Group</h2>
                  <div class="client-badge">{{ purchaseOrderNumber }}</div>
                </div>

                <div class="gray-bg-rounded mb-3">
                  <h2 class="p-2 mb-2 globalborder-btm-header">General</h2>
                  <form [formGroup]="linesGroupForm">
                    <div class="row p-2">
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Line Group</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            formControlName="lineGroup" />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Site</label>
                          <p-select
                            id="site"
                            formControlName="site"
                            [options]="siteDropDown"
                            placeholder="Select Site">
                          </p-select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Warehouse</label>
                          <p-select
                            id="site"
                            formControlName="warehouse"
                            [options]="wareHouseDropDown"
                            placeholder="Select Warehouse">
                          </p-select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Location</label>
                          <p-select
                            id="site"
                            formControlName="location"
                            [options]="filterLocationDropDown"
                            placeholder="Select Location">
                          </p-select>
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Job Name</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            formControlName="jobName"
                            (focusout)="updateLines()" />
                        </div>
                      </div>
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Owner</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            formControlName="owner" />
                        </div>
                      </div>
                    </div>
                    <div class="row p-2">
                      <div class="col-md-2">
                        <div class="form-group has-float-label">
                          <label class="form-label">Mock GP%</label>
                          <input
                            pInputText
                            jniAutoCompleteBlocker
                            type="text"
                            formControlName="mockGPercentage" />
                        </div>
                      </div>
                    </div>
                  </form>
                </div>

                <jni-inventory-purchase-finished-goods-listing
                  #finishedGoodsComponent
                  [selectedLineGroup]="selectedLineGroup"
                  [finishedGoodsList]="finishedGoodsList"
                  [purchaseOrderNumber]="purchaseOrderNumber"
                  [site]="purchaseOrderHeader?.siteD365 || ''"
                  [warehouse]="purchaseOrderHeader?.warehouseD365 || ''"
                  [owner]="purchaseOrderHeader?.ownerD365 || ''"
                  [parent]="linesGroupForm"
                  (rowSaveEvent)="onRowEditSave($event)"
                  (copyLinesEvent)="copyPOLine($event)"
                  (deleteLinesEvent)="deleteInventoryLine($event)"
                  (selectedLineGroupChangeEvent)="
                    selectedLineGroupChangeEvent($event)
                  ">
                </jni-inventory-purchase-finished-goods-listing>

                <jni-inventory-purchase-line-services
                  #serviceLineComponent
                  [selectedLineGroup]="selectedLineGroup"
                  [purchaseOrderHeader]="purchaseOrderHeader"
                  [purchaseOrderHeaderAddress]="purchaseOrderHeaderAddress"
                  [purchaseOrderNumber]="purchaseOrderNumber"
                  [serviceLines]="serviceLines"
                  [site]="purchaseOrderHeader?.siteD365 || ''"
                  [warehouse]="purchaseOrderHeader?.warehouseD365 || ''"
                  [parent]="linesGroupForm"
                  [shippingProductsList]="shippingProductsList"
                  [customerId]="purchaseOrderHeader?.clientProspectNumber || ''"
                  (rowSaveEvent)="onRowEditSave($event)"
                  (copyLinesEvent)="copyPOLine($event)"
                  (deleteLinesEvent)="deleteInventoryLine($event)"
                  (addNewServiceLine)="addNewServiceLine()"
                  (setServiceItemLine)="setServiceItemLine($event)"
                  (saveLines)="onSave()">
                </jni-inventory-purchase-line-services>

                <div class="row justify-content-end">
                  <div class="col-auto">
                    <!-- <button
                    type="button"
                    class="btn btn-primary"
                    (click)="onCancel()">
                    Cancel
                  </button> -->

                    <p-button label="Cancel" (click)="onCancel()" />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </p-card>
  </div>
</div>

<jni-child-po-confirmation
  [printPdfModal]="printPdfModal"
  [purchaseOrderLine]="purchaseOrderLine"
  (closePrintPdfModalEvent)="closePrinfPdfModal()">
</jni-child-po-confirmation>
<jni-modal-stacker
  *ngIf="inventoryServiceLinesDisplayModal"
  [displayModal]="inventoryServiceLinesDisplayModal"
  (closeEvent)="closeModalFromInventoryServiceLines()"
  class="modal-header-sticky">
  <div class="panelBody">
    <!-- <jni-inventory-purchase-lines
      [purchaseOrderNumber]="samplePONumber"
      [fromStacker]="true"
      (closeEvent)="closeModalFromSamplePOSummary()"
    ></jni-inventory-purchase-lines> -->
    <jni-inventory-purchase-line-services-form
      [parent]="linesGroupForm"
      [saleOrderIdFromModal]="purchaseOrderNumber"
      [lineGroup]="selectedLineGroup"
      [site]="purchaseOrderHeader?.siteD365 || ''"
      [warehouse]="purchaseOrderHeader?.warehouseD365 || ''"
      [saleOrderModalStatus]="true"
      (closeEvent)="closeModalFromInventoryServiceLines()"
      [selectedServiceLine]="selectedServiceLine"
      (rowEditSave)="onRowEditSave($event)"
      [orderLineNumberFromModal]="selectedOrder"
      (resetSelectedServiceLine)="resetSelectedServiceLine()"
      (displayServiceLine)="
        toggleModal($event)
      "></jni-inventory-purchase-line-services-form>
  </div>
</jni-modal-stacker>

<jni-modal-stacker
  *ngIf="createFinishedGoodsDisplayModal"
  [displayModal]="createFinishedGoodsDisplayModal"
  (closeEvent)="closeModalFromCreateFinishedGoods()"
  class="modal-header-sticky">
  <div class="panelBody">
    <jni-finished-goods-template
      [parent]="linesGroupForm"
      [saleOrderIdFromModal]="purchaseOrderNumber"
      [lineGroup]="selectedLineGroup"
      [site]="purchaseOrderHeader?.siteD365 || ''"
      [warehouse]="purchaseOrderHeader?.warehouseD365 || ''"
      [saleOrderModalStatus]="true"
      [jobNameD365]="linesGroupForm.get('jobName')?.value || ''"
      [wMSLocationD365]="linesGroupForm.get('location')?.value || ''"
      [owner]="purchaseOrderHeader?.ownerD365 || ''"
      [store]="purchaseOrderHeader?.storeD365 || ''"
      (closeEvent)="closeModalFromCreateFinishedGoods()"
      (closeModalEmit)="closeModalFromCreateFinishedGoods()"
      (refreshGridEmit)="ngOnInit()"></jni-finished-goods-template>
  </div>
</jni-modal-stacker>
<p-confirmDialog
  [appendTo]="'body'"
  header="Confirmation"
  icon="pi pi-exclamation-triangle">
  <ng-template pTemplate="footer">
    <button
      pButton
      label="Yes"
      icon="pi pi-check"
      (click)="dialogBoxButtonEvent(1)"
      class="p-button p-confirm-dialog-accept p-button-sm"></button>

    <button
      pButton
      label="No"
      icon="pi pi-times"
      (click)="dialogBoxButtonEvent(2)"
      class="p-button p-confirm-dialog-reject p-button-sm p-button-text"></button>
  </ng-template>
</p-confirmDialog>
